import { PRODUCT_VOTES_API } from "@/lib/constants";
import { TProductVotes, Votes } from "@/shared/service/votes/productv2-vote";

class VotesApi implements Votes {
	async getProductVotesCount(slug: string): Promise<TProductVotes> {
		const res = await fetch(`${PRODUCT_VOTES_API}/${slug}`, {
			credentials: "include",
			next: { revalidate: 3 },
		});
		if (!res.ok) {
			console.error("Vote fetch failed:", await res.text());
			return { data: { votesCount: 0, isUpvotedByUser: false, usersWhoVoted: [], score: 0 } };
		}
		return await res.json();
	}
}

export const votesApi = new VotesApi();
